import React from 'react'

const ProfileIcon = () => (
  <svg
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.40771 13.3457C5.08081 13.3457 1.38574 13.9305 1.38574 16.2724C1.38574 18.6143 5.05737 19.22 9.40771 19.22C13.7346 19.22 17.4286 18.6343 17.4286 16.2933C17.4286 13.9524 13.7581 13.3457 9.40771 13.3457Z"
      stroke="#00112B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.40764 10.0059C12.2471 10.0059 14.5486 7.94779 14.5486 5.40969C14.5486 2.8716 12.2471 0.814453 9.40764 0.814453C6.56815 0.814453 4.26566 2.8716 4.26566 5.40969C4.25607 7.93922 6.54258 9.99731 9.37142 10.0059H9.40764Z"
      stroke="#00112B"
      strokeWidth="1.42857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ProfileIcon
